<template>
  <div>
        <a-card>
            <div class="text-center mb-0">
                <span>订单ID：</span><span>{{orderId}}</span>
            </div>
            <div class="text-center mb-3">
                <span>实付金额：</span>
                <span class="color-red size4">￥</span>
                <span class="color-red" style="font-size: 40px" v-if="totalMoney">{{totalMoney}}</span>
            </div>


            <div>
                <a-tabs :defaultActiveKey="defaultActiveKey" tabPosition="bottom" :tabBarStyle="tabBarStyle">
                    <a-tab-pane key="1" :forceRender="forceRender">
                    <span slot="tab">
                        <img src='../../img/wxpay.png' style="margin: auto">
                    </span>
                        <img :src="wxPayUrl" style="margin: auto;height: 220px">
                    </a-tab-pane>
                    <a-tab-pane key="2" :forceRender="forceRender">
                    <span slot="tab">
                        <img src='../../img/alipay.png'>
                    </span>
                        <iframe style="width: 220px;height: 220px;margin: auto;border: none;display: block" :src="aliUrl"></iframe>
                    </a-tab-pane>
                </a-tabs>
                <div style="text-align: center;"><a-button @click="onBack">返回</a-button></div>
<!--                <div style="text-align: center;"><a-button @click="onSuccess">模拟支付成功</a-button></div>-->
            </div>

        </a-card>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import qs from 'qs'
import {Decimal} from 'decimal.js'
export default {
    props: ["orderId"],
    created() {
        this.initOrderList()
    },
  name: 'Step2',
  data () {
    return {
      labelCol: { lg: { span: 5 }, sm: { span: 5 } },
      wrapperCol: { lg: { span: 19 }, sm: { span: 19 } },
      form: this.$form.createForm(this),
      loading: false,
      timer: 0,
        data: [],
        queryParam: {},
        projectId: '',
        selectedRowKeys: [],
        payVisible: false,
        totalFee: 0,
        packOrder: {
            packsIds: '',
            totalMoney: ''
        },
        wxPayUrl: '',
        totalMoney: '',
        payTimer: null,
        forceRender: true,
        defaultActiveKey: 1,
        aliUrl: "",
        tabBarStyle: {
            "border-bottom": "none"
        }
    }
  },
  methods: {
    nextStep () {
      const that = this
      const { form: { validateFields } } = this
      that.loading = true
      validateFields((err, values) => {
        if (!err) {
          console.log('表单 values', values)
          that.timer = setTimeout(function () {
            that.loading = false
            that.$emit('nextStep')
          }, 1500)
        } else {
          that.loading = false
        }
      })
    },
     initOrderList() {
          if (!this.orderId) {
              this.error("订单ID异常!")
              return
          }
         this.initData(this.orderId)
      },
      finish() {
        this.$emit("finish")
      },
      error(val) {
          this.$error({
              title: '提示',
              content: val
          })
      },
      onSubmit() {
      },
      onBack() {
        clearInterval(this.payTimer)
        this.$router.push({path:'/announce/AnnounceIndex'})
      },
      onSuccess(){
        let that = this
          that.$http.get('/api/v1/supplier/legalsign/getLhtSupplier.json',{params:{orderId:this.orderId}}).then(function (res) {
           if (res.code === 200)
           {
               that.$emit('finish')
           }
       })
      },
      nextStep() {
          this.$emit('nextStep')
      },
      close() {
          this.payVisible = false
      },
      setRow(record) {
          return {
              on: {
                  click: () => {
                      let rowKeys = this.selectedRowKeys;
                      if (rowKeys.length > 0 && rowKeys.includes(record.key)) {
                          rowKeys.splice(rowKeys.indexOf(record.key), 1);
                      } else {
                          rowKeys.push(record.key);
                      }
                      this.selectedRowKeys = rowKeys;
                  }
              }
          };
      },

    prevStep () {
      this.$emit('prevStep')
    },
      btn() {
        this.$emit("btn")
      },
      test() {
          clearInterval(this.payTimer)
          this.$emit('cancel')
          this.$emit("finish")
      },
      initData (orderId) {
          this.orderId = orderId
          this.aliUrl = "/supplier/alipay.html?orderId=" + orderId
          let that = this
          this.$http.get('/api/v1/supplier/sign/get_pack_supplier.json?orderId=' + orderId).then(function (res) {
              that.totalMoney = res.totalMoney
              that.wxPayUrl = res.wxPayUrl
              that.payTimer = setInterval(function () {
                  that.$http.get('/api/v1/supplier/sign/pay-state.json?orderId=' + orderId).then(function (res) {
                      if (res.code === 200) {
                          //关闭计时器，返回首页
                          clearInterval(that.payTimer)
                          that.$emit('finish')
                      }
                  })
              }, 1000)
          })
      },
  },
  beforeDestroy () {
    clearInterval(this.payTimer)
    clearTimeout(this.timer)
  }
}
</script>

<style lang="less" scoped>
  /deep/ .ant-tabs-nav-scroll{
      text-align: center;
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab{
      opacity: 0.5;
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab-active{
      opacity: 1;
  }
</style>
